import React from 'react';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function PrivacyPage() {
  return <>
      <Navigation data-id="element-273" />

      <main className="wrap report-main" data-id="element-274">
        <article className="report" data-id="element-275">
          {/* frontmatter */}
          <header className="frontmatter" data-id="element-276">
            <div className="fm-cell" data-id="element-277">
              <span className="lbl" data-id="element-278">Document</span>
              <span className="val" data-id="element-279">Privacy Policy</span>
            </div>
            <div className="fm-cell" data-id="element-280">
              <span className="lbl" data-id="element-281">Updated</span>
              <span className="val" data-id="element-282">January 2026</span>
            </div>
            <div className="fm-cell" data-id="element-283">
              <span className="lbl" data-id="element-284">Status</span>
              <span className="val" data-id="element-285">Active</span>
            </div>
          </header>

          {/* HERO */}
          <section className="hero" data-id="element-286">
            <div className="kicker" data-id="element-287">Andoe / Legal</div>
            <h1 data-id="element-288">Privacy Policy</h1>
            <p className="lede" data-id="element-289">
              Andoe ("we", "us", or "our") values your privacy. This Privacy
              Policy explains how we collect, use, share, and protect
              information when you use Andoe, including our website and
              services.
            </p>
            <p className="abstract" data-id="element-290">
              By using Andoe, you agree to the practices described in this
              policy.
            </p>
          </section>

          <section className="report-section" data-id="element-291">
            <div className="section-head" data-id="element-292">
              <div className="section-num" data-id="element-293">01</div>
              <div className="section-title" data-id="element-294">
                <h2 data-id="element-295">Information We Collect</h2>
                <span className="deck" data-id="element-296">Data necessary to operate Andoe.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-297">
              <div className="pad" data-id="element-298"></div>
              <div className="content" data-id="element-299">
                <div className="entry" data-id="element-300">
                  <h3 data-id="element-301">Information you provide</h3>
                  <ul style={{
                  margin: '8px 0',
                  paddingLeft: '20px',
                  color: 'var(--ink-2)',
                  fontSize: '15px'
                }} data-id="element-302">
                    <li data-id="element-303">
                      <strong data-id="element-304">Account information:</strong> name, email address,
                      login credentials
                    </li>
                    <li data-id="element-305">
                      <strong data-id="element-306">Billing information:</strong> when you purchase a
                      plan (processed by our payment processor)
                    </li>
                    <li data-id="element-307">
                      <strong data-id="element-308">Customer content:</strong> prompts, inputs,
                      configuration, and other content you submit
                    </li>
                    <li data-id="element-309">
                      <strong data-id="element-310">Communications:</strong> messages you send to us
                      (support, feedback, inquiries)
                    </li>
                  </ul>
                </div>
                <div className="entry" data-id="element-311">
                  <h3 data-id="element-312">Information collected automatically</h3>
                  <ul style={{
                  margin: '8px 0',
                  paddingLeft: '20px',
                  color: 'var(--ink-2)',
                  fontSize: '15px'
                }} data-id="element-313">
                    <li data-id="element-314">
                      <strong data-id="element-315">Usage data:</strong> pages visited, features used,
                      actions taken within the product
                    </li>
                    <li data-id="element-316">
                      <strong data-id="element-317">Technical data:</strong> IP address, browser type,
                      device type, timestamps
                    </li>
                    <li data-id="element-318">
                      <strong data-id="element-319">Cookies and similar technologies:</strong> used
                      for authentication, session management, and basic
                      analytics
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-320">
            <div className="section-head" data-id="element-321">
              <div className="section-num" data-id="element-322">02</div>
              <div className="section-title" data-id="element-323">
                <h2 data-id="element-324">How We Use Information</h2>
                <span className="deck" data-id="element-325">
                  Operating and improving the service.
                </span>
              </div>
            </div>
            <div className="section-body" data-id="element-326">
              <div className="pad" data-id="element-327"></div>
              <div className="content" data-id="element-328">
                <div className="entry" data-id="element-329">
                  <ul style={{
                  margin: '8px 0',
                  paddingLeft: '20px',
                  color: 'var(--ink-2)',
                  fontSize: '15px'
                }} data-id="element-330">
                    <li data-id="element-331">Provide and operate the Service</li>
                    <li data-id="element-332">Authenticate users and manage accounts</li>
                    <li data-id="element-333">Process prompts and generate analytics and insights</li>
                    <li data-id="element-334">Communicate with you about the product</li>
                    <li data-id="element-335">
                      Monitor performance, prevent abuse, and maintain security
                    </li>
                    <li data-id="element-336">Improve features, usability, and reliability</li>
                  </ul>
                  <p style={{
                  marginTop: '16px'
                }} data-id="element-337">
                    <strong data-id="element-338">We do not sell your personal information.</strong>
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-339">
            <div className="section-head" data-id="element-340">
              <div className="section-num" data-id="element-341">03</div>
              <div className="section-title" data-id="element-342">
                <h2 data-id="element-343">Customer Content</h2>
                <span className="deck" data-id="element-344">
                  How we handle your prompts and data.
                </span>
              </div>
            </div>
            <div className="section-body" data-id="element-345">
              <div className="pad" data-id="element-346"></div>
              <div className="content" data-id="element-347">
                <div className="entry" data-id="element-348">
                  <p data-id="element-349">
                    Content you submit to Andoe, such as prompts, queries, and
                    configuration data, is used solely to provide functionality,
                    generate analytics, and operate the Service.
                  </p>
                  <p style={{
                  marginTop: '16px'
                }} data-id="element-350">
                    We do not use your customer content for advertising
                    purposes. You are responsible for ensuring you have the
                    rights to submit any content, including client or
                    third-party data.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-351">
            <div className="section-head" data-id="element-352">
              <div className="section-num" data-id="element-353">04</div>
              <div className="section-title" data-id="element-354">
                <h2 data-id="element-355">Service Providers</h2>
                <span className="deck" data-id="element-356">
                  Third parties that help us operate.
                </span>
              </div>
            </div>
            <div className="section-body" data-id="element-357">
              <div className="pad" data-id="element-358"></div>
              <div className="content" data-id="element-359">
                <div className="entry" data-id="element-360">
                  <p data-id="element-361">
                    We use trusted third-party service providers (hosting,
                    authentication, analytics, payment processors, AI models) to
                    help operate Andoe.
                  </p>
                  <p style={{
                  marginTop: '16px'
                }} data-id="element-362">
                    These providers may process data only as necessary to
                    provide their services to us and are contractually obligated
                    to protect it. Your data may be processed in Canada, the
                    United States, and other jurisdictions where our service
                    providers operate.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-363">
            <div className="section-head" data-id="element-364">
              <div className="section-num" data-id="element-365">05</div>
              <div className="section-title" data-id="element-366">
                <h2 data-id="element-367">Data Security & Retention</h2>
                <span className="deck" data-id="element-368">Protecting and keeping your data.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-369">
              <div className="pad" data-id="element-370"></div>
              <div className="content" data-id="element-371">
                <div className="entry" data-id="element-372">
                  <h3 data-id="element-373">Security</h3>
                  <p data-id="element-374">
                    We implement reasonable administrative, technical, and
                    organizational safeguards designed to protect your
                    information. However, no system is perfectly secure. You are
                    responsible for maintaining the confidentiality of your
                    login credentials.
                  </p>
                </div>
                <div className="entry" data-id="element-375">
                  <h3 data-id="element-376">Retention</h3>
                  <p data-id="element-377">
                    We retain personal information and customer content while
                    your account is active. After account termination, we may
                    retain data for a limited period for legal compliance,
                    security, dispute resolution, or enforcement of our Terms.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="report-section" data-id="element-378">
            <div className="section-head" data-id="element-379">
              <div className="section-num" data-id="element-380">06</div>
              <div className="section-title" data-id="element-381">
                <h2 data-id="element-382">Your Rights & Contact</h2>
                <span className="deck" data-id="element-383">Managing your information.</span>
              </div>
            </div>
            <div className="section-body" data-id="element-384">
              <div className="pad" data-id="element-385"></div>
              <div className="content" data-id="element-386">
                <div className="entry" data-id="element-387">
                  <h3 data-id="element-388">Your Rights</h3>
                  <p data-id="element-389">
                    Depending on your location, you may have rights to access
                    your personal information, request correction or deletion,
                    or withdraw consent. You can make requests by contacting us.
                  </p>
                </div>
                <div className="entry" data-id="element-390">
                  <h3 data-id="element-391">Contact</h3>
                  <p data-id="element-392">
                    If you have questions about this Privacy Policy or your
                    data, contact us at:{' '}
                    <a href="mailto:jason@andoe.work" style={{
                    color: 'var(--ink)',
                    textDecoration: 'underline'
                  }} data-id="element-393">
                      jason@andoe.work
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </section>

          <Footer data-id="element-394" />
        </article>

        <pre className="json-view" data-id="element-395">
          {`// privacy policies are for humans, not for AI to parse.
// 
// read the document above. it was written for you.`}
        </pre>
      </main>
    </>;
}